export default __webpack_public_path__ + "static/media/10_banner-machine-learn.2d824028.jpg";